module.exports = __webpack_public_path__ + "static/media/logo-white.3c82c70e.png";